import yekan from "./yekan";
import titr from "./titr";
import iransans from "./iransans";

export default {
  vfs: {
    ...yekan,
    ...titr,
    ...iransans,
  },

  fonts: {
    Yekan: {
      normal: "BYEKAN.OTF",
      bold: "BYEKAN.OTF",
    },

    Titr: {
      normal: "BTITR.OTF",
      bold: "BTITR.OTF",
    },

    Nillima: {
      normal: "BYEKAN.OTF",
      bold: "BYEKAN.OTF",
    },

    IRANSans: {
      normal: "IRANSans_UltraLight.ttf",
      bold: "IRANSans_UltraLight.ttf",
    },
  },
};
